export default {
  INDEX: 10
};